export const NO_ADS_PRODUCT_KEY = "no_ads";
export const NO_ADS_PRICE_KEY = "no_ads";
export const NO_ADS_PRICE_LABEL = "$0.99";

export function noAdsCheckoutPlan() {
    return {
        name: "No Ads",
        price: NO_ADS_PRICE_LABEL,
        productKey: NO_ADS_PRODUCT_KEY,
        priceKey: NO_ADS_PRICE_KEY,
        successPath: "/account/profile",
    };
}

/** True when this account purchased No Ads. Premium plans are handled separately. */
export function accountHasNoAdsPurchase(cloudUser) {
    const flag = cloudUser?.details?.noAds;
    return flag === true || flag === "true";
}
